module.exports = __webpack_public_path__ + "img/da7a843.jpg";